import { render, staticRenderFns } from "./MdmSkipTo.vue?vue&type=template&id=409e808f&"
import script from "./MdmSkipTo.vue?vue&type=script&lang=js&"
export * from "./MdmSkipTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports